import swal from "sweetalert2";

import template from "./entity-header-modal.html";
import "./entity-header-modal.less";
import { getPrimaryClassificationsForType } from "../../getAllowedClassifications";
import {
	EVENT_LOGOUT, 
	TIME_ZONES 
} from "../../../../constants";
import {
	ENTITY_TRANSLATION_KEYS, 
	I18NextContext 
} from "../../../../services/i18nService";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import { v7 as uuid } from "uuid";

export function controller(
	uiHelpers, 
	appState, 
	loadingService, 
	eventBus, 
	$scope, 
	$logger
) {
	const ctrl = this;

	ctrl.promiseTracker = loadingService.getTracker();

	ctrl.$onInit = onInit;
	ctrl.$onDestroy = ctrl.cancel;
	ctrl.entityHeader = {};
	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;

	ctrl.isSupportedOrNullish = isSupportedOrNullish;
	
	function onInit() {
		ctrl.typeConfig = { ...ctrl.resolve.typeConfig };
		ctrl.permissions = ctrl.resolve.permissions;

		ctrl.timezones = [
			{
				code: "",
				ianaCode: ""
			},
			...TIME_ZONES
		];

		ctrl.allClassifications = getPrimaryClassificationsForType(
			ctrl.typeConfig.Classifications, 
			appState.forms.selected.Agency.Classifications
		);

		ctrl.tooltipTranslations = {
			code: ctrl.i18n.translateEntityType(ctrl.typeConfig.Code, ENTITY_TRANSLATION_KEYS.LABELS.Code, `${ctrl.typeConfig.Name} Number`),
			name: ctrl.i18n.translateEntityType(ctrl.typeConfig.Name, ENTITY_TRANSLATION_KEYS.LABELS.Name, `${ctrl.typeConfig.Name} Name`),
			classification: ctrl.i18n.translateEntityType(ctrl.typeConfig.Classification, ENTITY_TRANSLATION_KEYS.LABELS.Classification, "Classification"),
			externalKey: ctrl.i18n.translateEntityType(ctrl.typeConfig.ExternalKey, ENTITY_TRANSLATION_KEYS.LABELS.ExternalKey, "External Key"),
			timezone: ctrl.i18n.translateEntityType(ctrl.typeConfig.Timezone, ENTITY_TRANSLATION_KEYS.LABELS.Timezone, "Timezone")
		};

		ctrl.useNameComponent = !ctrl.typeConfig.Contact.IsSupported ? "text" : "contact";
		ctrl.nameComponentSwitchable = !ctrl.typeConfig.Contact.IsRequired && !!ctrl.typeConfig.Contact.IsSupported;

		if(ctrl.typeConfig.IsCodeSystemManaged) {
			ctrl.entityHeader.Code = uuid();
		}

		if(ctrl.typeConfig.IsExternalKeySystemManaged) {
			ctrl.entityHeader.ExternalKey = uuid();
		}

		eventBus.register(EVENT_LOGOUT, () => { ctrl.cancel(); }, $scope);
	}

	ctrl.cancel = () => {
		ctrl.modalInstance.dismiss();
	};

	ctrl.save = async() => {
		if(validate()) {
			await ctrl.resolve.save(ctrl.entityHeader);
			ctrl.modalInstance.close(ctrl.entityHeader);
		}
	};

	ctrl.setClassificationBox = (box) => {
		ctrl.classificationBox = box;

		const selectionChoices = uiHelpers.setDisplay(
			ctrl.allClassifications, 
			{ 
				recentlyUsedEnabled: false, 
				hideCode: true 
			}
		);

		if(ctrl.classificationBox) {
			ctrl.classificationBox.setChoices(selectionChoices, "value", "label", true);
		}
	};

	ctrl.setDisplay = (id, fieldVariable) => {
		const item = ctrl[fieldVariable].find(i => (i.Id === parseInt(id)) || (i.Id === id));

		if(!item) {
			$logger.warn(`Selected ${fieldVariable} not found as an option.`);
		}

		return item.Name || item.Code;
	};

	ctrl.handleClassificationValueChanged = (modelVal) => {
		const modelValInt = parseInt(modelVal);
		const selectedClassification = ctrl.allClassifications.find(a => a.Id === modelValInt);

		ctrl.entityHeader.Classification = selectedClassification ? { Code: selectedClassification.Code } : undefined;
	};

	function validate() {
		const validationStrings = [];

		if(ctrl.entityHeader.Code === undefined) {
			validationStrings.push(`${ctrl.tooltipTranslations.code} is required`);
		}

		if((ctrl.typeConfig.TimeZone === undefined || ctrl.typeConfig.TimeZone.IsRequired) && ctrl.entityHeader.TimeZone === undefined) {
			validationStrings.push(`${ctrl.tooltipTranslations.timezone} is required`);
		}

		if(
			(ctrl.typeConfig.IsNameDefaultedToCodeWhenNoContact !== true || ctrl.entityHeader.Contact !== undefined) // code is copied to name in saveEntity()
			&& (
				(isSupportedOrNullish(ctrl.typeConfig.Contact) && ctrl.entityHeader.Name === undefined && ctrl.entityHeader.Contact === undefined)
				|| (ctrl.typeConfig.Contact.IsRequired && ctrl.entityHeader.Contact === undefined)
				|| (!ctrl.typeConfig.Contact.IsSupported && ctrl.entityHeader.Name === undefined)
			)
		) {
			validationStrings.push(`${ctrl.tooltipTranslations.name} is required`);
		}

		if(ctrl.typeConfig.Classification?.IsRequired && ctrl.entityHeader.Classification === undefined) {
			validationStrings.push(`${ctrl.tooltipTranslations.classification} is required`);
		}
		
		if(ctrl.typeConfig.ExternalKey?.IsRequired && (ctrl.entityHeader.ExternalKey === undefined || ctrl.entityHeader.ExternalKey.trim() === "")) {
			validationStrings.push(`${ctrl.tooltipTranslations.externalKey} is required`);
		}

		if(ctrl.typeConfig.CodePattern !== undefined) {
			const exp = new RegExp(ctrl.typeConfig.CodePattern);
			const isMatch = exp.test(ctrl.entityHeader.Code);

			if(!isMatch) {
				validationStrings.push("Code is not a valid pattern");
			}
		}
		
		if(ctrl.typeConfig.NamePattern !== undefined) {
			const exp = new RegExp(ctrl.typeConfig.NamePattern);
			const isMatch = exp.test(ctrl.entityHeader.Name);

			if(!isMatch) {
				validationStrings.push("Entity Name is not a valid pattern");
			}
		}

		if(validationStrings.length > 0) {
			const errorList = `<ul><li>${validationStrings.join("</li><li>")}</li></ul>`;

			swal.fire({
				title: "Correct Missing Information",
				html:
					`<p>Please correct the following errors</p>
					${errorList}
					`,
				showCloseButton: true,
				type: "warning"
			});

			return false;
		}

		return true;
	}
}

export default angular.module("vesl.components.entity-header-modal", [])
	.component("entityHeaderModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<",
			reload: "&"
		}
	})
	.name;
